export default __webpack_public_path__ + "static/media/scissors-teaser.daa6ab0f.gif";